import sum from './sum';

function average(numbers) {
  if (numbers.length === 0) return 0;

  return sum(numbers) / numbers.length;
}

export default average;
